'use strict';

$(document).ready(function __createAccountDomReady() {
    $('.create-account--form').each(function __createAccountForm() {
        var $container = $(this);
        $('[data-target]').on('click', function __eachClickTarget() {
            $('.' + $(this).data('target')).first().click();
        });

        $('form button[type=submit]', $container).click(function () {
            $(this).attr('disabled', 'disabled');
            submitCreateAccount();
            return false;
        });

        $('form', $container).on('submit', function () {
            $('input[type=submit]').attr('disabled', 'disabled');
        });

        window['executeCreateAccount'] = function (token) {
            $('form', $('.create-account--form')).submit();
        }

        function submitCreateAccount() {
            if (captcha.isEnabledAndInvisible()) {
                captcha.executeCaptcha();
            } else {
                $('form', $('.create-account--form')).submit();
            }
        }

        if($(".error-standard").length !== 0) {
            $(".error-standard").get(0).scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    });
});
